





















































import { computed, defineComponent, inject, ref, Ref } from '@nuxtjs/composition-api';
import { ProductData } from '~/features/product';
import { useProductReviews } from '~/features/reviews';
import { PRODUCT_CONTEXT } from '~/utils/provides';

export default defineComponent({
  name: 'ProductPageReviews',
  setup() {
    const product = inject(PRODUCT_CONTEXT) as Ref<ProductData>;
    // used for virtual pagination as we fetch all reviews
    const reviewPageSize = ref(6);
    const { reviews, isFetching } = useProductReviews({
      pageSize: product.value.review_count || 1,
      slug: product.value.url_key as string,
    });
    const ratingBreakdown = computed(() => {
      const stars: Record<string, number> = { '5': 0, '4': 0, '3': 0, '2': 0, '1': 0 };

      return reviews.value.reduce((acc, curr: any) => {
        const rating = ((curr.averageRating * 5) / 100).toFixed(0);
        acc[rating]++;

        return acc;
      }, stars);
    });

    function nextPage() {
      if (reviewPageSize.value > product.value.review_count) {
        return;
      }

      reviewPageSize.value += 6;
    }

    return {
      product,
      ratingBreakdown,
      reviews,
      isFetching,
      reviewPageSize,
      nextPage,
    };
  },
});
